/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {ListItem, makeStyles} from '@material-ui/core';
import {Theme} from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import classnames from 'classnames';
import {dlsColor, dlsTypography} from '../../../src/theme/theme';

interface AssetDetailListItemType {
  issueClick?: () => void;
  issueCount?: number | string;
  title: string;
  children?: any;
  listOpen: boolean
}

const useStyles = makeStyles((theme: Theme) => {
  const {
    dls: {
      motion: {
        element: {
          smallExpansion: {
            close: expansionClose,
            open: expansionOpen
          }
        }
      }
    }
  } = theme;
  return {
    root : {
      width           : '100%',
      backgroundColor : dlsColor('white'),
      justifyContent  : 'space-between',
      alignItems      : 'center',
      '&:hover'       : {
        cursor : 'pointer'
      }
    },
    expand : {
      marginLeft : 'auto'
    },
    expandIcon : {
      transition : `transform ${expansionClose}`,
      '&:hover'  : {
        cursor : 'pointer'
      }
    },
    expandOpen : {
      transform  : 'rotateZ(180deg)',
      transition : `transform ${expansionOpen}`
    },
    issueLabel : {
      ...dlsTypography('panelCards'),
      color : dlsColor('grey2')
    },
    issueCount : {
      marginLeft : '5px'
    },
    detailItemChildWrapper : {
      maxHeight  : '0px',
      padding    : '0 16px',
      transition : `max-height ${expansionClose}, padding ${expansionClose}`,
      overflow   : 'hidden'
    },
    openList : {
      maxHeight  : '1000px',
      padding    : '28px 16px',
      transition : `max-height ${expansionOpen}, padding ${expansionOpen}`
    }
  };
});

const AssetDetailListItem = ({
  issueClick,
  issueCount,
  title,
  children,
  listOpen = false
}: AssetDetailListItemType) => {
  const classes = useStyles();
  return (
    <>
      <ListItem className={classes.root} onClick={issueClick}>
        <div className={classes.issueLabel}>
          {title}
          {!!issueCount && <span className={classes.issueCount}>{`(${issueCount})`}</span>}
        </div>
        <span className={classes.expand}>
          <ExpandMore className={
            classnames(classes.expandIcon, listOpen ? classes.expandOpen : null)
          } />
        </span>
      </ListItem>
      <div className={
        classnames(classes.detailItemChildWrapper, listOpen ? classes.openList : null)
      }>
        {children}
      </div>
    </>
  );
};

export default AssetDetailListItem;
